import { doc, onSnapshot, Unsubscribe } from 'firebase/firestore';
import { db } from '../../firebase/config';
import { apiClient } from './apiClient';
import {
  DEFAULT_WHATSAPP_SETTINGS,
  WhatsAppSettings
} from '../../types/models/whatsapp';

const SETTINGS = 'whatsapp_settings';
const SETTINGS_DOC = 'global';

/**
 * Account-wide toggles. Single document — this deployment is single-tenant.
 *
 * Read live so a change by one admin reaches every open inbox; written through
 * the API, which whitelists the keys.
 */
class SettingsService {
  subscribe(
    onChange: (settings: WhatsAppSettings) => void,
    onError?: (error: Error) => void
  ): Unsubscribe {
    if (!db) {
      // Without Firestore, fall back to defaults rather than leaving the UI
      // in a permanent loading state.
      onChange({ ...DEFAULT_WHATSAPP_SETTINGS });
      return () => {};
    }

    return onSnapshot(
      doc(db, SETTINGS, SETTINGS_DOC),
      (snapshot) => {
        onChange({
          ...DEFAULT_WHATSAPP_SETTINGS,
          ...(snapshot.exists() ? (snapshot.data() as Partial<WhatsAppSettings>) : {})
        });
      },
      (error) => {
        console.error('❌ Settings subscription error:', error);
        onChange({ ...DEFAULT_WHATSAPP_SETTINGS });
        onError?.(error as Error);
      }
    );
  }

  async update(
    updates: Partial<WhatsAppSettings>
  ): Promise<{ settings: WhatsAppSettings }> {
    return apiClient.patch<{ settings: WhatsAppSettings }>('/settings', updates);
  }
}

export const settingsService = new SettingsService();
export default settingsService;
